/**
 * Home
 *
 * Scripts for home page.
 *
 * @since 1.0.0
 */

// import $ from 'jquery';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
